import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DonutComponent, DonutChartComponent, LegendComponent, StatusBarComponent, 
    UsageBarComponent } from '../ui-components/';

@NgModule({
    imports: [CommonModule],
    declarations: [
        DonutComponent,
        DonutChartComponent,
        LegendComponent,
        StatusBarComponent,
        UsageBarComponent
    ],
    exports: [
        DonutComponent,
        DonutChartComponent,
        LegendComponent,
        StatusBarComponent,
        UsageBarComponent
    ]
})
export class ChartLibModule { }
